import React from "react";
import { motion } from "framer-motion";
import { fadeTop, motionStep } from "./motion";
import Featured from "./Featured";
import apartmentsite from "../../assets/apartmentsite.png";
import bashableart from "../../assets/generateai.png";
import publicgoods from "../../assets/publicgoods.png"
import template from "../../assets/template.mp4"
import adalet from "../../assets/adaletgpt2.png"
import wego from "../../assets/wego.png"
import Section from "../common/Section";
import ProjectCard from "./ProjectCard";
import RightSvg from "../../assets/svg/right-pattern.svg";
import blaze from "../../assets/blaze.png";

export const projectsData = [
  {
    id: 0,
    thumbnail: blaze,
    title: "Blaze Gaming Sports",
    description:
      "The project is Blaze Gaming, a web-based platform that covers online gaming, including casino games, sports betting, and live dealer experiences. The tech stack included Express.js for the backend, React.js for the frontend, MongoDB for data storage, Material-UI and TailwindCSS for UI, WebSockets with Socket.io for real-time updates, and Stripe for payment processing. I was responsible for designing and implementing the full system, making sure it was secure, high-performance, and responsive. I built backend controllers such as GameController with functions like getAvailableGames(), startGameSession(userId, gameId), and updateGameResult(sessionId, result). I also created a PaymentController with processPayment(orderId, paymentDetails) and verifyTransaction(paymentId) to handle Stripe integration safely. Business logic, like validating bets, calculating winnings, and managing live dealer sessions, was handled in service classes such as GameService and PaymentService to keep controllers clean. I also optimized database queries in MongoDB for speed and reliability, using indexes and caching frequently requested game data.",
    live: "https://blaze1.space",
    code: "#",
    tech: ["Next.js", "Tailwind CSS", "Typescript", "Node.js"],
    featured: true,
  },
  {
    id: 1,
    thumbnail: wego,
    title: "Skyscanner Travelling Website",
    description:
      "This project was a Travel Agency platform that allows users to search, compare, and book flights, hotels, and car rentals worldwide. The tech stack included React.js and TypeScript for the frontend, Node.js/Express for backend APIs, REST API integrations with third-party flight and hotel providers, and caching mechanisms. I mainly worked on the frontend development, focusing on building a fast, responsive, and user-friendly interface. I built components such as SearchResults, FlightCard, and PriceAlertForm, and created hooks like useFetchFlights() and usePriceTracker() to handle API calls efficiently. I also developed services to manage data fetching and caching, for example FlightService.getFlights(params) and HotelService.getAvailableRooms(params).",
    live: "https://skyscanner.net",
    code: "#",
    tech: ["Next.js", "Tailwind CSS", "Typescript", "Node.js", "PostgreSQL", "WebSocket", "Stripe"],
    featured: true,
  },
  {
    id: 2,
    thumbnail: publicgoods,
    title: "Public Goods",
    description:
      "The project was built on Shopify Plus and included custom theme development using Liquid, HTML5, and Tailwind CSS. I focused heavily on performance and accessibility, ensuring a seamless experience for users, including those relying on screen readers or keyboard navigation. The store features a unique membership and subscription model that offers members discounted pricing, free shipping, and early access to product launches. I developed a tailored checkout flow and integrated third-party subscription tools to support this functionality. A key part of the project was creating a smart refill system that simplifies product replenishment while helping reduce plastic waste.",
    live: "https://publicgoods.com/",
    code: "#",
    tech: ["Liquid", "JavaScript", "Shopify API", "GraphQL", "RabbitMQ"],
    featured: true,
  },
  {
    id: 3,
    thumbnail: adalet,
    title: "Adalet Law Chatbot",
    description:
      "I implemented a Retrieval Augmented Generation (RAG) pipeline using Langchain, GPT-4, OpenAI embedding, and Pinecone vectorstore. This project involved integrating Google Search for supplementary data and setting up two Pinecone indexes—one for laws and regulations and another for legal cases. The system intelligently retrieves relevant information based on the user’s query, using agent functionality in Langchain to select the appropriate tool for the query.",
    live: "https://adaletgpt.com",
    code: "#",
    tech: ["Langchain", "GPT-4", "OpenAI Embedding", "Pinecone", "Google Search"],
    featured: true,
  },
  {
    id: 7,
    video: template,
    title: "Template Manage System Shopify App",
    description:
      "This is a custom web application that allowed users to upload their own artwork for personalized gift boxes.",
    live: "#",
    code: "#",
    tech: ["Next.js", "Node.js", "Mongodb", "Node.js"],
    featured: false
  },
  {
    id: 8,
    thumbnail: bashableart, 
    title: "Bashable Art  App",
    description: "Bashable is an AI tool to generate beautiful realstic images.",
    live: "#",
    code: "#",
    featured: false,
    tech: ["Next", "Node", "ubuntu", "TailwindCSS"]
  },
  {
    id: 9,
    thumbnail: apartmentsite,
    title: "Flair Multifamily Technology Studio",
    description: "This is a custom web application that allowed users to upload their own artwork for personalized gift boxes.",
    live: "#",
    code: "#",
    featured: false,
    tech: ["Next.js", "Tailwind CSS", "Typescript", "Node.js", "PostgreSQL", "WebSocket", "Stripe"]
  },
];

const Projects = () => {
  return (
    <Section
      id="projects"
      title="Portfolio"
      subtitle="Recent projects upon which I have worked on."
      className="relative"
    >
      <div className="space-y-5 lg:space-y-10 px-5 md:px-10 lg:px-20 2xl:px-40 mb-8">
        {/* Right SVG */}
        <img
          src={RightSvg}
          alt=""
          className="absolute hidden right-0 bottom-2/4 w-2/12 max-w-xs md:block"
          loading="lazy"
          height={700}
          width={320}
        />
        {projectsData
          .filter((e) => e.featured === true)
          .map((e, i) => (
            <motion.div key={i} variants={fadeTop} {...motionStep}>
              <Featured
                live={e.live}
                thumbnail={e.thumbnail}
                code={e.code}
                title={e.title}
                description={e.description}
                tech={e.tech}
                secondary={i % 2 === 0 ? false : true}
              />
            </motion.div>
          ))}
      </div>

      <div className="grid grid-cols-8 2xl:grid-cols-12 gap-6 gap-y-8 my-10 px-5 md:px-10 lg:px-20 2xl:px-40">
        {projectsData
          .filter((e) => e.featured !== true)
          .map((e, i) => (
            <ProjectCard
              live={e.live}
              thumbnail={e.thumbnail}
              code={e.code}
              title={e.title}
              description={e.description}
              tech={e.tech}
              video={e.video}
              key={i}
            />
          ))}
      </div>
    </Section>
  );
};

export default Projects;
